import {ColumnsType} from 'antd/es/table';
import {t} from 'i18next';
import {DateFilterDropdown} from 'views/serviceActions/utils/ServicesUtils';
import {ReservationDto} from '../../../../../PRMGApiClient';

export const ganttReservationsColumns: ColumnsType<ReservationDto> = [
  {
    title: t('Car'),
    dataIndex: 'car',
    key: 'car',
    // className: 'w-32',
    filterMode: 'tree',
    filterSearch: true,
  },
  {
    title: t('Customer'),
    key: 'customer',
    dataIndex: 'customer',
  },
  {
    title: t('Start date'),
    key: 'begins',
    dataIndex: 'begins',
    filterDropdown: (props) => <DateFilterDropdown dataIndex="startDateTime" {...props} />,
  },
  {
    title: t('End date'),
    key: 'ends',
    dataIndex: 'ends',
    filterDropdown: (props) => <DateFilterDropdown dataIndex="endDateTime" {...props} />,
  },
];
